import { Component, OnInit } from '@angular/core';
import { Observable, Subscription, Subject } from 'rxjs/';
import { SmartModalService } from 'app/core/services/smart-modal.service';

@Component({
	selector: 'itpx-address-edit',
	templateUrl: './address-edit.component.html',
	styleUrls: ['./address-edit.component.css']
})
export class AddressEditComponent implements OnInit {

	private details: any;

	constructor(
		private modalService: SmartModalService
	) { }

	ngOnInit() {
		this.details = Object.assign({}, this['data']);
	}
	private isCancel(){ 
		this.modalService.sendResult(null)
	}
	private isSaved() {
		this.modalService.sendResult('success')
	}
 	
}



// WEBPACK FOOTER //
// ./src/app/organization/components/organization-details/organization-details-edit/address/address-edit/address-edit.component.ts